export function getOtherQuestions() {
  return {
    platformName: {
      id: '',
      name: '',
    },
    bigCommerce: {
      id: 'bigCommerce',
      name: 'BigCommerce',
    },
    etsy: {
      id: 'etsy',
      name: 'Etsy',
    },
    wooCommerce: {
      id: 'wooCommerce',
      name: 'WooCommerce',
    },
    magento: {
      id: 'magento',
      name: 'Magento',
    },
  };
}
